type ColorChartProps = {
  readonly colors: {
    readonly name: string;
    readonly image: string;
  }[];
  readonly title: string;
};

const ColorChart = ({ colors, title }: ColorChartProps) => {
  return (
    <section className="flex justify-center max-sm:my-[45px] md:my-[50px] xl:my-[100px] mt-4">
      <div className="w-full max-sm:px-4">
        <div className="flex flex-col">
          <h2 className="font-chivo-bold max-sm:text-xl text-[25px] max-sm:pb-5 md:pb-[45px]">{title}</h2>
          <ul className="xs:self-start s:self-center md2:w-full xs:w-4/5 grid xs:grid-cols-2 md2:grid-cols-3 xl:grid-cols-5 max-sm:gap-y-3 md:gap-y-[25px] xs:gap-x-[70px] md2:gap-x-[15px]">
            {colors.map((color, index) => (
              <li key={index}>
                <figure className="flex flex-col max-sm:w-[166px] md:w-[200px] max-sm:h-[111px] md:h-[141px]">
                  <img className="w-full max-sm:h-[80px] h-[96px] object-contain" src={color.image} alt={color.name} />
                  <figcaption className="max-sm:text-xs text-sm text-left pt-[10px]">
                    <span className="font-chivo-bold">{color.name}:</span>
                    <span className="max-sm:font-chivo-bold md:font-chivo-regular"> </span>
                  </figcaption>
                </figure>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ColorChart;